<template>

  <div class="padded">

    <xolas-table
      :title="utilLabel + ' Bills'"
      table-ref="utilbillingtable"
      :url="url"
      :fields="siteFields"
      sort-field="siteName"
      search-placeholder="Site Ids, Site Names, Addresses, Account..."
      layer-component="siteUtil"
      :layer-args="{ id: 'id' }">

      <template #bills-slot="props">
        <div class="bills-actions">
          <utility-action button-size="small" :site-data="props.rowData" />
          <utility-payment-action v-if="canAccess('finance')" button-size="small" :site-data="props.rowData" />
        </div>
      </template>

    </xolas-table>

  </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

import UtilityAction from '@/components/actions/UtilityBillAction'
import UtilityPaymentAction from '@/components/actions/UtilityBillPayAction'

export default {
  mixins: [SiteMixins],

  components: {
    UtilityAction,
    UtilityPaymentAction
  },

  props: {
    sharer: {
      type: Number,
      default: null
    }
  },

  watch: {
    sharer: function (value) {
      this.telcoId = value
    }
  },

  computed: {
    url: function () {
      return '/utility/site/bills'
    }
  },

  data () {
    return {
      utilLabel: this.getUtilLabel(),
      telcoId: this.sharer,
      siteFields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id',
          width: 70,
          align: 'center'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          visible: this.isTowerCo(),
          callback: this.formatSiteStatus,
          width: 90,
          align: 'center'
        },
        {
          name: 'siteId',
          title: 'Site ID',
          sortField: 'siteId',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: 140
        },
        {
          name: 'siteName',
          title: 'Site Name',
          sortField: 'siteName',
          minWidth: 200
        },
        {
          name: 'tenancy.utilAccount',
          title: this.getUtilLabel() + ' Account #',
          minWidth: 140
        },
        {
          name: 'tenancy.utilLastBill',
          title: 'Last Bill',
          minWidth: 100
        },
        {
          name: '__slot:bills-slot',
          title: '',
          width: 230,
          align: 'right'
        }
      ]
    }
  },

  mounted () {
    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }
  }
}
</script>

<style scoped>
.bills-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
</style>
